<template>
	<div class="grid justify-center">
		<img
			src="/assets/img/icons/tabler-icon-rotate-clockwise.svg"
			class="animate-spin"
			alt="Ladevorgang Icon"
			aria-label="Die Seite lädt derzeit. Bitte um etwas Geduld."
		/>
	</div>
</template>
